

import axios from 'axios'
import Vue from 'vue'
import store from '../stores/index'
const BACKEND_URL = process.env.BACKEND_URL
const STAFF_URL = process.env.BACKEND_URL+"staff/"
const guild = new Vue ({
  beforeCreate(){
    axios.defaults.withCredentials = true;
  },
    methods : {
        getChannels(){
            const url = `${STAFF_URL}${store.getters.staffGuild}/guild/channels`
            return axios.get(url).then(response => response.data)
        },
        getRoles(){
            const url = `${STAFF_URL}${store.getters.staffGuild}/guild/roles`
            return axios.get(url).then(response => response.data)
        },
        getRolePerms(){
          const url = `${STAFF_URL}${store.getters.staffGuild}/guild/roleperms`
          return axios.get(url).then(response => response.data)
       },
       getEmotes(){
         const url = `${STAFF_URL}${store.getters.staffGuild}/guild/emotes`
         return axios.get(url).then(response => response.data)
        },
        subscribe(id){
          const url = `${STAFF_URL}${store.getters.staffGuild}/guild/subscribe`
          return axios.post(url,{channelId:id}).then(response => response.data)
        }
    },
  })
  

  
  export default {
    install: function(Vue) {
      Vue.prototype.$guild = guild
    }
  }


// WEBPACK FOOTER //
// ./src/api/guild.js